export default __webpack_public_path__ + "static/media/potree.5797b321.webp";